import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { space } from 'folio-common-components';
import { invariant } from 'folio-common-utils';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PageCard } from '../../components/Section';
import { ButtonLink } from '../../components/buttons';
import { PageHeading } from '../../components/page-heading';
import { Pitch } from '../../components/pitch';
import { SmallArrowLeftIcon } from '../../icons';
import { pageMap } from '../../paths';
import { useSelector } from '../../state';
import { getOnboardingUrl } from '../../utils';

const Heading = PageHeading.withComponent('h3');

const FindOutMorePage: React.FC = () => {
  const { bankSelection, id, willHaveEmployees } = useSelector(e => ({
    id: e.founding.id,
    bankSelection: e.founding.bankSelection,
    willHaveEmployees: e.founding.foundingDetails?.willHaveEmployees,
  }));
  const location = useLocation();
  const onboardingUrl = getOnboardingUrl(id, bankSelection);

  invariant(willHaveEmployees, 'Expected an employee question to be defined');

  return (
    <PageCard>
      <div css={space([16], 'margin-bottom')}>
        <Link to={{ pathname: pageMap.status, search: location.search }}>
          <SmallArrowLeftIcon
            css={css`
              margin-right: 8px;
              position: relative;
              top: 1px;
            `}
          />
          Tilbake
        </Link>
      </div>

      <PageHeading>Folio bedriftskonto</PageHeading>

      <p>
        Folio er vår samarbeids&shy;partner som leverer bankkonto. Bruker du
        Folio, får du konto kjappere, og slipper skaffe dokumenter fra banken
        for å stifte selskapet ditt. Dette er den raskeste veien til AS!
      </p>

      <Heading css={space([48], 'margin-top')}>
        Fiken + Folio gir mange fordeler:
      </Heading>

      <Pitch willHaveEmployees={willHaveEmployees} />

      <Section>
        <p>
          <ButtonLink href={onboardingUrl}>
            Fortsett med konto fra Folio
          </ButtonLink>
        </p>

        <div
          css={css`
            text-align: center;
          `}
        >
          <Link to={{ pathname: pageMap.status, search: location.search }}>
            Gå tilbake
          </Link>
        </div>
      </Section>
    </PageCard>
  );
};

const Section = styled.div`
  ${space([32], 'margin-top')}
`;

// React.lazy only supports default exports:
// https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default FindOutMorePage;
